/**
 * @generated SignedSource<<b53ba97919a789db4608ca26de0412b3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteActionVersionHistoryMutation$variables = {
  connections: ReadonlyArray<string>;
  id: string;
};
export type DeleteActionVersionHistoryMutation$data = {
  readonly deleteDatasetVersion: string;
};
export type DeleteActionVersionHistoryMutation = {
  response: DeleteActionVersionHistoryMutation$data;
  variables: DeleteActionVersionHistoryMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "datasetVersionId",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "kind": "ScalarField",
  "name": "deleteDatasetVersion",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteActionVersionHistoryMutation",
    "selections": [
      (v3/*:: as any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DeleteActionVersionHistoryMutation",
    "selections": [
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "filters": null,
        "handle": "deleteEdge",
        "key": "",
        "kind": "ScalarHandle",
        "name": "deleteDatasetVersion",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e727389650865f963233375026127f77",
    "id": null,
    "metadata": {},
    "name": "DeleteActionVersionHistoryMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteActionVersionHistoryMutation(\n  $id: ID!\n) {\n  deleteDatasetVersion(datasetVersionId: $id)\n}\n"
  }
};
})();

(node as any).hash = "e943025f21813059ca879061359d18cc";

export default node;
